export default "__VITE_ASSET__e0c5e7da__"